const routes = [
    {
        path: "/student/slots/bulk",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "studentslot_bulksearch"
        }
    }
]

export default routes;
